import { useEffect, useState } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useToastContext } from '../../../../contexts'
import {
  TrialGenerateResponseDto,
  TrialTemplate,
  requestGenerateTrialBo,
} from '../../data'
import Generatebo from './Generatebo'

const GenerateboContainer: React.FC = () => {
  const { t, i18n } = useTranslation()
  const { showToast } = useToastContext()
  const [isRequestRunning, setIsRequestRunning] = useState<boolean>(false)
  const [selectedTemplate, setSelectedTemplate] = useState<
    TrialTemplate | undefined
  >()

  useEffect(() => {
    setSelectedTemplate(undefined)
  }, [i18n.language])

  const onSelectedTemplateChanged = (template: TrialTemplate) => {
    if (template) {
      setSelectedTemplate(template)
    }
  }

  const onRequestGenerateBo = async (): Promise<void> => {
    setIsRequestRunning(true)

    try {
      const result = (await requestGenerateTrialBo(
        selectedTemplate?.Name || '',
        i18n.language,
      )) as TrialGenerateResponseDto

      showToast({
        id: `generatedbo_${result.generatedId}`,
        severity: 'success',
        summary: t('trial.generatebo.messages.success.summary'),
        detail: t('trial.generatebo.messages.success.detail', {
          orderId: result.generatedId,
        }),
      })

      setSelectedTemplate(undefined)
    } catch (error) {
      showToast({
        id: `generatedbo_error`,
        sticky: true,
        severity: 'error',
        summary: t('trial.generatebo.messages.failure.summary'),
        detail: t('trial.generatebo.messages.failure.detail'),
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  return (
    <Generatebo
      selectedTemplate={selectedTemplate}
      onSelectedTemplateChanged={onSelectedTemplateChanged}
      onRequestGenerateBo={onRequestGenerateBo}
      isRequestRunning={isRequestRunning}
      canGenerate={!!selectedTemplate}
    />
  )
}

export default GenerateboContainer
